
  const initializeMultiSelect = (selectId, options) => {
    const combobox = document.getElementById(selectId);
    const selectTextfield = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Wrapper');
    const dropdownWrapper = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Dropdown-Wrapper');
    const selectLabel = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Label');
    const selectChevronIcon = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Modifier-Chevron');
    const selectLockIcon = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Modifier-Lock');
    const optionElements = dropdownWrapper.querySelectorAll('.Dynamic-Select-Multi-Select-Filter-Option');
    const selectContent = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Content');
    const clearOptionsBtnSelect = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Modifier-Delete');
    const selectCaption = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Caption');
    const clearOptionsBtnDropdown = document.getElementById(`${selectId}-Dropdown-Clear-Button`);
    const showBtnDropdown = document.getElementById(`${selectId}-Dropdown-Show-Button`);
    const filterTextfieldWrappers = document.querySelectorAll('.Dynamic-Select-Multi-Select-Filter-Textfield-Wrapper');
    const mobileFilterContainer = document.querySelector('.Weiterbildungen-Filter-Wrapper');
    const mobileFilterBackdrop = document.querySelector('.Weiterbildungen-Filter-Backdrop-Mobile');
    const mobileFilterHeading = document.querySelector('.Weiterbildungen-Filter-Content-Header-Wrapper-Mobile-Text');
    const mobileFilterBackChevron = document.getElementById('Weiterbildungen-Filter-Content-Header-Wrapper-Mobile-Back-SVG');
    const mobileFilterButtonBox = document.querySelector('.Weiterbildungen-Filter-Button-Wrapper-Mobile');
    const mobileFilterClearBtn = document.getElementById('Weiterbildungen-Filter-Reset-Button-Mobile');
    let isMobile = window.matchMedia("(max-width: 767px)").matches;

    if(!isMobile){
      mobileFilterContainer.classList.remove('hide');
    }
    
    const updateSelectedOptions = () => {
      const selectedOptions = Array.from(optionElements).filter(option => option.getAttribute('aria-selected') === 'true');
      selectContent.innerHTML = '';
      if (selectedOptions.length > 0 && !isMobile) {
        selectedOptions.forEach(option => {
          const text = option.querySelector('.Dynamic-Select-Multi-Select-Filter-Option-Text').textContent;
          const badge = createBadge(text);
          selectContent.appendChild(badge);
        });
        toggleClass(selectTextfield, 'filled', true);
        toggleClass(clearOptionsBtnSelect, 'hide', false);
        clearOptionsBtnDropdown.disabled = false;
      } else {
        
        const label = combobox.getAttribute('data-label') || 'Select';
        const placeholder = combobox.getAttribute('data-placeholder') || 'Choose options';
  
       if (isMobile) {
          if(selectedOptions.length > 0){
            selectContent.textContent = `${label} (${selectedOptions.length})`;
            mobileFilterClearBtn.disabled = false;
          } else{
            selectContent.textContent = `${label}`;
            updateAllSelectedOptions();
          }
        } else {
            selectContent.textContent = placeholder;
        }
        toggleClass(selectTextfield, 'filled', false);
        toggleClass(clearOptionsBtnSelect, 'hide', true);
        clearOptionsBtnDropdown.disabled = selectedOptions.length === 0;
      }
    };

    if (options.preselected.length > 0) {
      options.preselected.forEach(optionValue => {
        const option = Array.from(optionElements).find(opt => opt.getAttribute('data-value') === optionValue);
        if (option) {
          option.setAttribute('aria-selected', 'true');
        }
      });
      updateSelectedOptions();
    }

    selectTextfield.addEventListener('click', () => {
      if (!options.locked && !options.disabled) {
        const isExpanded = combobox.getAttribute('aria-expanded') === "true";
        combobox.setAttribute('aria-expanded', !isExpanded);
        dropdownWrapper.classList.toggle('show');
        if (isMobile) {
          filterTextfieldWrappers.forEach(el => el.classList.add('hide'));
          mobileFilterHeading.textContent = options.label;
          mobileFilterBackChevron.classList.remove('hide');
          mobileFilterButtonBox.classList.add('hide');
        }
      }
    });

    dropdownWrapper.addEventListener('click', (e) => {
      const option = e.target.closest('.Dynamic-Select-Multi-Select-Filter-Option');
      if (option) {
        const isSelected = option.getAttribute('aria-selected') === 'true';
        option.setAttribute('aria-selected', !isSelected);
        updateSelectedOptions();
        if (typeof window.updateFilters === 'function') window.updateFilters();
      }
    });

    document.addEventListener('click', (e) => {
      if (!selectTextfield.contains(e.target) && !dropdownWrapper.contains(e.target) && !isMobile) {
        combobox.setAttribute('aria-expanded', 'false');
        dropdownWrapper.classList.remove('show');
      }
    });

    clearOptionsBtnSelect.addEventListener('click', (e) => {
      e.stopPropagation();
      optionElements.forEach(opt => opt.setAttribute('aria-selected', 'false'));
      updateSelectedOptions();
      if (typeof window.updateFilters === 'function') window.updateFilters();
    });

    clearOptionsBtnDropdown.addEventListener('click', (e) => {
      e.stopPropagation();
      optionElements.forEach(opt => opt.setAttribute('aria-selected', 'false'));
      updateSelectedOptions();
      if (typeof window.updateFilters === 'function') window.updateFilters();
    });

    showBtnDropdown.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!isMobile) {
        const isExpanded = combobox.getAttribute('aria-expanded') === "true";
        combobox.setAttribute('aria-expanded', !isExpanded);
        dropdownWrapper.classList.toggle('show');
      } else {
        mobileFilterContainer.classList.add('hide');
        mobileFilterBackdrop.classList.add('hide');
        filterTextfieldWrappers.forEach(el => el.classList.remove('hide'));
        mobileFilterHeading.textContent = 'Filter';
        mobileFilterBackChevron.classList.add('hide');
        mobileFilterButtonBox.classList.remove('hide');
      }
    });

    selectContent.addEventListener('click', (e) => {
      if (e.target.closest('.Dynamic-Select-Multi-Select-Filter-Badge-Clear')) {
        e.stopPropagation();
        const badge = e.target.closest('.Dynamic-Select-Multi-Select-Filter-Badge');
        const text = badge.textContent.trim();
        const option = Array.from(optionElements).find(opt => opt.querySelector('.Dynamic-Select-Multi-Select-Filter-Option-Text').textContent === text);
        if (option) {
          option.setAttribute('aria-selected', 'false');
          updateSelectedOptions();
          if (typeof window.updateFilters === 'function') window.updateFilters();
        }
      }
    });

    window.addEventListener("resize", () => {
      isMobile = window.matchMedia("(max-width: 768px)").matches;
    });
  };


  const toggleClass = (element, className, add) => {
    if (element) {
      add ? element.classList.add(className) : element.classList.remove(className);
    }
  };

  const createBadge = (text) => {
    const badge = document.createElement('span');
    badge.className = 'Dynamic-Select-Multi-Select-Filter-Badge responsive-text2--bold';
    badge.innerHTML = `
      ${text}
      <button class="Dynamic-Select-Multi-Select-Filter-Badge-Clear" aria-label="Remove ${text}">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="#601EE3" width="12" height="12">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    `;
    return badge;
  };

  const updateAllSelectedOptions = (comboboxes) => {
    
  var comboboxes = document.querySelectorAll('.Dynamic-Select-Multi-Select-Filter-Container');
  comboboxes.forEach(combobox => {
  
    const selectTextfield = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Wrapper');
    const optionElements = combobox.querySelectorAll('.Dynamic-Select-Multi-Select-Filter-Option');
    const selectContent = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Content');
    const clearOptionsBtnSelect = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Textfield-Modifier-Delete');
    const clearOptionsBtnDropdown = combobox.querySelector('.Dynamic-Select-Multi-Select-Filter-Dropdown-Clear-Button');
    const mobileFilterClearBtn = document.getElementById('Weiterbildungen-Filter-Reset-Button-Mobile');
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    
    const selectedOptions = Array.from(optionElements).filter(option => option.getAttribute('aria-selected') === 'true');
    selectContent.innerHTML = '';
    
    if (selectedOptions.length > 0 && !isMobile) {
      selectedOptions.forEach(option => {
        const text = option.querySelector('.Dynamic-Select-Multi-Select-Filter-Option-Text').textContent;
        const badge = createBadge(text);
        selectContent.appendChild(badge);
      });
      toggleClass(selectTextfield, 'filled', true);
      toggleClass(clearOptionsBtnSelect, 'hide', false);
      clearOptionsBtnDropdown.disabled = false;
    } else {
      const label = combobox.getAttribute('data-label') || 'Select';
      const placeholder = combobox.getAttribute('data-placeholder') || 'Choose options';
  
      if (isMobile) {
        if(selectedOptions.length > 0){
          selectContent.textContent = `${label} (${selectedOptions.length})`;
        } else{
          selectContent.textContent = `${label}`;
        }
      } else {
          selectContent.textContent = placeholder;
      }

      toggleClass(selectTextfield, 'filled', false);
      toggleClass(clearOptionsBtnSelect, 'hide', true);
      clearOptionsBtnDropdown.disabled = selectedOptions.length === 0;
    }
    
  });

    var isMobile = window.matchMedia("(max-width: 767px)").matches;
    var mobileFilterClearBtn = document.getElementById('Weiterbildungen-Filter-Reset-Button-Mobile');
    var optionElements = document.querySelectorAll('.Dynamic-Select-Multi-Select-Filter-Option');
    var selectedOptions = Array.from(optionElements).filter(option => option.getAttribute('aria-selected') === 'true');
     if (isMobile && selectedOptions.length > 0) {
          mobileFilterClearBtn.disabled = false;
        } else{
          mobileFilterClearBtn.disabled = true;
        }
      
};


  window.initializeMultiSelect = initializeMultiSelect;

